import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
}
export function AccordionItem({
  question,
  answer
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-700 last:border-0" data-id="element-245">
      <button onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} className="w-full py-4 px-2 flex items-center justify-between text-left hover:bg-slate-800/50 transition-colors rounded-lg" data-id="element-246">
        <span className="font-bold text-white text-lg" data-id="element-247">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-248">
          <ChevronDown className="w-5 h-5 text-emerald-400" data-id="element-249" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-250">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-251">
            <div className="pb-4 px-2 text-slate-300 leading-relaxed" data-id="element-252">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}